<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 09:02:22
 * @Description: 甘特图右侧下方区选中背景色行
-->
<!-- 甘特图背景网格 -->
<template>
  <div
    class="select-row"
    :data-rowId="rowId"
    :style="{
      'height': (rowsShowMap && rowsShowMap[rowId]? estimatedItemSize * rowsShowMap[rowId].rowCount: estimatedItemSize)  + 'px',
      'top': (estimatedItemSize * (rowsShowMap && rowsShowMap[rowId]? rowsShowMap[rowId].startRow - 1 : -1))  + 'px'
    }"
  >
  </div>
</template>
<script>
export default {
  name: "SelectRow",
  props: {
    rowId: {
      type: String,
      default: () => { return "default"; },
    },
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
    rowsShowMap: {
      type: Object,
      default: () => { return null; },
    },
  },
  data() {
    return {

    };
  },
  mounted() {
    
  },
};

</script>
<style scoped lang='less'>
.select-row{
  background: @cWBSRowBg;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;

}
</style>
